// extracted by mini-css-extract-plugin
export var statItem = "_fi-1";
export var statsRow = "_fi-0";